<template>
  <label
    class="custom-checkbox-wrapper"
    :class="[wrapperClass, { 'is-checked': modelValue }]"
    :aria-disabled="disabled"
  >
    <input
      type="checkbox"
      :checked="modelValue"
      :name="name"
      :disabled="disabled"
      class="custom-checkbox-input"
      @change="handleChange"
    />
    <span class="custom-checkbox-checkmark"></span>
    <span v-if="hasDefaultSlot" class="custom-checkbox-label-slot">
      <slot></slot>
    </span>
  </label>
</template>

<script setup>
import { defineProps, defineEmits, computed, useSlots } from "vue";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    default: "",
  },
  wrapperClass: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "change"]);

const handleChange = (event) => {
  emit("update:modelValue", event.target.checked);
  emit("change", event.target.checked);
};

const slots = useSlots();
const hasDefaultSlot = computed(() => !!slots.default);
</script>

<style scoped>
.custom-checkbox-wrapper {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  padding: 4px 0;
  color: var(--font-color);
  font-family: sans-serif;
  font-size: 1rem;
}

.custom-checkbox-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.custom-checkbox-checkmark {
  width: 30px;
  height: 30px;
  border: 2px solid var(--font-color);
  border-radius: 10px;
  background-color: var(--body-color);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  transition: all 0.2s ease-in-out;
  flex-shrink: 0;
}

.custom-checkbox-checkmark::after {
  content: "";
  width: 30px;
  height: 30px;
  background: url(../../../assets/img/icon/checked-green.svg) center center
    no-repeat;
  background-size: 30px 30px;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.custom-checkbox-input:checked + .custom-checkbox-checkmark {
  background-color: var(--body-color);
  border-color: var(--font-color);
}

.custom-checkbox-input:checked + .custom-checkbox-checkmark::after {
  opacity: 1;
}

.custom-checkbox-input:focus + .custom-checkbox-checkmark {
  box-shadow: 0 0 0 3px var(--brand-color);
}

.custom-checkbox-input:disabled + .custom-checkbox-checkmark {
  /* background-color: #e9ecef; */
  border-color: var(--brand-color);
  cursor: not-allowed;
}

.custom-checkbox-input:disabled + .custom-checkbox-checkmark::after {
  border-color: var(--font-color);
}

.custom-checkbox-input:disabled ~ .custom-checkbox-label-slot {
  opacity: 0.6;
  cursor: not-allowed;
}

.custom-checkbox-label-slot {
  line-height: 1.2;
}
</style>
